<!-- <ad-text (onFocus)="openPopup($event);" iconClass="fa-calendar"></ad-text> -->
<span #text class="dr-wrapper" [ngClass]="{'dr-focus':popupOverlayRef}">
    <span class="dr-icon fa fa-calendar"></span>
    <span class="dr-start-container"><input type="text" (focus)="openPopup($event);" readonly
            [value]="startFormatFun?startFormatFun(startDate,rangeDates):startDate"></span>
    <span class="dr-divider">-</span>
    <span class="dr-end-container"><input type="text" (focus)="openPopup($event);" readonly
            [value]="endFormatFun?endFormatFun(endDate,rangeDates):endDate"></span>
</span>